import { Badge, Button, Card, Popconfirm, Tooltip } from "antd"
import Meta from "antd/es/card/Meta"
import { CustomBtn } from "../../../../components/commonComponents"
import './card.css'

export const DepartmentCard = ({ department, statusChange, editDepartment }) => {
    return (
        <Card
            className="department-card"
            title={department?.code}
            style={{ width: 200 }}
            // bodyStyle={{ minHeight: 220 }}
            extra={
            
                    <Badge key="badge" color={department.is_deleted ? "red" : "green"} title={department.is_deleted ? "წაშლილი" : "არის გამოყენებული"} />
              
            }
            actions={[
                <Button key="edit" icon={<i className="fa-solid fa-pen-to-square"></i>} type="text" style={{ color: '#fadb14' }} onClick={() => { editDepartment(department) }} />,
                <Popconfirm
                    key="delete"
                    okText='კი'
                    cancelText='არა'
                    title={department.is_deleted ? `ნამდვილად გსურთ წაშლა?` : `ნამდვილად გსურთ აღდგენა?`}
                    onConfirm={() => { statusChange(department.id,department.is_deleted) }}

                >
                    <Button icon={<i className={department.is_deleted ? "fa-solid fa-check" :"fa-solid fa-trash" }></i>} type="text" style={{ color: department.is_deleted ? 'green' : 'red' }} />
                </Popconfirm>
            ]}
        >
            <Meta
                description={
                    <div>
                        <p>{department.name}</p>
                        <hr />
                        <p>{department.description}</p>
                    </div>
                }
            />

        </Card>
    )
}